/**
 * Reusable dropdown select component for form fields in node editing panels.
 */
import React from 'react';

interface SelectProps {
    opts: string[];
    value?: string;
    onChange: (value: string) => void;
    className?: string;
}

export default function Select({ opts, value, onChange, className = 'nodepanel-select' }: SelectProps) {
    return (
        <select className={className} value={value || ''} onChange={(e) => onChange(e.target.value)}>
            <option value=''>—</option>
            {opts.map((o) => (
                <option key={o} value={o}>
                    {o}
                </option>
            ))}
        </select>
    );
}
